import React from 'react';

const SobaTheme = ({ children }) => {
  return (
    <React.Fragment>
      {children}
    </React.Fragment>
  );
};

export default SobaTheme;

